export default __webpack_public_path__ + "static/media/coriander.c0b78e8a.png";